import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import Slider from '@material-ui/core/Slider'
import 'katex/dist/katex.min.css'

function SliderStaticComponent(props) {
  const {
    mcData,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    isPractice,
    handleSucAndFailFeedback
  } = props
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Answers,
    Score,
    Options,
    Background,
    AnswerColorFill,
    Description,
    QuestionColorFill,
    QuestionFontSize,
    Opacity,
    QuestionFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    Bold,
    Italic,
    FontStyle,
    AnswerFontSize,
    SequenceHint
  } = mcData

  const [value, setValue] = useState(1)
  const [slideOptionLength, setSlideOptionLength] = useState(0)
  const [sortedChoiceValueArray, setSortedChoiceValueArray] = useState([])
  const [sliderOptions, setSliderOptions] = useState()

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue.CtlValue) {
        let defaultValueSelected = defaultValue.CtlValue
        setValue(defaultValueSelected)
      }
    } else {
      setValue(1)
    }
  }, [defaultValue])

  useEffect(() => {
    let sliderValues = []
    for (let index = 0; index < Options.length; index++) {
      sliderValues.push({ value: index + 1, label: Options[index].Option })
    }
    setSliderOptions(sliderValues)
    setSortedChoiceValueArray(Options)
    setSlideOptionLength(Options.length)
  }, [])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, value)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let selectedAnswer = ''
    if (slideOptionLength === 3) {
      if (value === 1) {
        selectedAnswer = sortedChoiceValueArray[0].Option
      } else if (value === 2) {
        selectedAnswer = sortedChoiceValueArray[1].Option
      } else {
        selectedAnswer = sortedChoiceValueArray[2].Option
      }
    } else if (slideOptionLength === 4) {
      if (value === 1) {
        selectedAnswer = sortedChoiceValueArray[0].Option
      } else if (value === 2) {
        selectedAnswer = sortedChoiceValueArray[1].Option
      } else if (value === 3) {
        selectedAnswer = sortedChoiceValueArray[2].Option
      } else {
        selectedAnswer = sortedChoiceValueArray[3].Option
      }
    } else {
      if (value === 1) {
        selectedAnswer = sortedChoiceValueArray[0].Option
      } else if (value === 2) {
        selectedAnswer = sortedChoiceValueArray[1].Option
      } else if (value === 3) {
        selectedAnswer = sortedChoiceValueArray[2].Option
      } else if (value === 4) {
        selectedAnswer = sortedChoiceValueArray[3].Option
      } else {
        selectedAnswer = sortedChoiceValueArray[4].Option
      }
    }
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (selectedAnswer === correctAnswer) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  function handleOptionChange(optionValue) {
    onAttemptChange(1)
    let selectedAnswer = sortedChoiceValueArray[optionValue - 1].Option
    //let selectedAnswer = ''
    // if (slideOptionLength === 3) {
    //   if (optionValue === 1) {
    //     selectedAnswer = sortedChoiceValueArray[0].Option
    //   } else if (optionValue === 2) {
    //     selectedAnswer = sortedChoiceValueArray[1].Option
    //   } else {
    //     selectedAnswer = sortedChoiceValueArray[2].Option
    //   }
    // } else if (slideOptionLength === 4) {
    //   if (optionValue === 1) {
    //     selectedAnswer = sortedChoiceValueArray[0].Option
    //   } else if (optionValue === 2) {
    //     selectedAnswer = sortedChoiceValueArray[1].Option
    //   } else if (optionValue === 3) {
    //     selectedAnswer = sortedChoiceValueArray[2].Option
    //   } else {
    //     selectedAnswer = sortedChoiceValueArray[3].Option
    //   }
    // } else {
    //   if (optionValue === 1) {
    //     selectedAnswer = sortedChoiceValueArray[0].Option
    //   } else if (optionValue === 2) {
    //     selectedAnswer = sortedChoiceValueArray[1].Option
    //   } else if (optionValue === 3) {
    //     selectedAnswer = sortedChoiceValueArray[2].Option
    //   } else if (optionValue === 4) {
    //     selectedAnswer = sortedChoiceValueArray[3].Option
    //   } else {
    //     selectedAnswer = sortedChoiceValueArray[4].Option
    //   }
    // }
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (selectedAnswer === correctAnswer) {
      handleSuccessChange(true)
    } else {
      handleSuccessChange(false)
    }
    validateCorrectAnswer(false, optionValue)
  }

  useEffect(() => {
    let x1 = document.styleSheets[0]
    x1.addRule(
      '.MuiSlider-markLabel',
      'color:' + AnswerColorFill + '!important'
    )
    x1.addRule('.MuiSlider-root', 'color:' + SelectionColor + '!important')
    x1.addRule('.MuiSlider-thumb', 'color:' + AnswerColorFill + '!important')
    x1.addRule('.MuiSlider-thumb', 'height:' + '20px' + '!important')
    x1.addRule('.MuiSlider-thumb', 'width:' + '20px' + '!important')
    x1.addRule('.MuiSlider-thumb', 'border: #ffc42d 5px solid !important')
    x1.addRule('.MuiSlider-thumb', 'margin-top:' + '-10px' + '!important')

    x1.addRule('.MuiSlider-track', 'height:' + '5px' + '!important')
    x1.addRule('.MuiSlider-track', 'border-radius:' + '10px' + '!important')
    x1.addRule('.MuiSlider-rail', 'height:' + '5px' + '!important')
    x1.addRule('.MuiSlider-rail', 'border-radius:' + '10px' + '!important')

    if (Bold === 'True') {
      x1.addRule('.MuiSlider-markLabel', 'font-weight:bold !important')
    }
    if (Italic === 'True') {
      x1.addRule('.MuiSlider-markLabel', 'font-style:italic !important')
    }
    x1.addRule(
      '.MuiSlider-markLabel',
      'font-family:' + FontStyle + '!important'
    )
    x1.addRule('.MuiSlider-mark', 'height:' + '60%' + '!important')
    x1.addRule('.MuiSlider-mark', 'width:' + '1px' + '!important')
    x1.addRule('.MuiSlider-mark', 'background-color:' + '#000' + '!important')

    if (AnswerFontSize === 'SMALL') {
      x1.addRule(
        '.MuiSlider-markLabel',
        'font-size:' + SMALL_DESKTOP + '!important'
      )
    } else if (AnswerFontSize === 'LARGE') {
      x1.addRule(
        '.MuiSlider-markLabel',
        'font-size:' + LARGE_DESKTOP + '!important'
      )
    } else {
      x1.addRule(
        '.MuiSlider-markLabel',
        'font-size:' + MEDIUM_DESKTOP + '!important'
      )
    }
  }, [])

  function validateAnswer() {
    let selectedAnswer = ''
    if (
      sortedChoiceValueArray[value - 1] &&
      sortedChoiceValueArray[value - 1].Option
    ) {
      selectedAnswer = sortedChoiceValueArray[value - 1].Option
    }
    let isCorrect = false
    // if (slideOptionLength === 3) {
    //   if (value === 1) {
    //     selectedAnswer = Options[0].Option
    //   } else if (value === 2) {
    //     selectedAnswer = Options[1].Option
    //   } else {
    //     selectedAnswer = Options[2].Option
    //   }
    // } else if (slideOptionLength === 4) {
    //   if (value === 1) {
    //     selectedAnswer = Options[0].Option
    //   } else if (value === 2) {
    //     selectedAnswer = Options[1].Option
    //   } else if (value === 3) {
    //     selectedAnswer = Options[2].Option
    //   } else {
    //     selectedAnswer = Options[3].Option
    //   }
    // } else {
    //   if (value === 1) {
    //     selectedAnswer = Options[0].Option
    //   } else if (value === 2) {
    //     selectedAnswer = Options[1].Option
    //   } else if (value === 3) {
    //     selectedAnswer = Options[2].Option
    //   } else if (value === 4) {
    //     selectedAnswer = Options[3].Option
    //   } else {
    //     selectedAnswer = Options[4].Option
    //   }
    // }
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (selectedAnswer === correctAnswer) {
      isCorrect = true
    } else {
      isCorrect = false
    }
    return isCorrect
  }

  function validateCorrectAnswer(timerValue, optionValue) {
    let selectedAnswer = sortedChoiceValueArray[optionValue - 1].Option

    // if (slideOptionLength === 3) {
    //   if (optionValue === 1) {
    //     selectedAnswer = sortedChoiceValueArray[0].Option
    //   } else if (optionValue === 2) {
    //     selectedAnswer = sortedChoiceValueArray[1].Option
    //   } else {
    //     selectedAnswer = sortedChoiceValueArray[2].Option
    //   }
    // } else if (slideOptionLength === 4) {
    //   if (optionValue === 1) {
    //     selectedAnswer = sortedChoiceValueArray[0].Option
    //   } else if (optionValue === 2) {
    //     selectedAnswer = sortedChoiceValueArray[1].Option
    //   } else if (optionValue === 3) {
    //     selectedAnswer = sortedChoiceValueArray[2].Option
    //   } else {
    //     selectedAnswer = sortedChoiceValueArray[3].Option
    //   }
    // } else {
    //   if (optionValue === 1) {
    //     selectedAnswer = sortedChoiceValueArray[0].Option
    //   } else if (optionValue === 2) {
    //     selectedAnswer = sortedChoiceValueArray[1].Option
    //   } else if (optionValue === 3) {
    //     selectedAnswer = sortedChoiceValueArray[2].Option
    //   } else if (optionValue === 4) {
    //     selectedAnswer = sortedChoiceValueArray[3].Option
    //   } else {
    //     selectedAnswer = sortedChoiceValueArray[4].Option
    //   }
    // }
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (selectedAnswer === correctAnswer) {
          onPriorityChange(Priority)
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (selectedAnswer === correctAnswer) {
      onValueChange(
        ControlID,
        optionValue,
        Score,
        Score,
        sortedChoiceValueArray,
        timerValue
      )
      if (isEmbeded) {
        handleSucAndFailFeedback(true)
      }
    } else {
      onValueChange(
        ControlID,
        optionValue,
        0,
        Score,
        sortedChoiceValueArray,
        timerValue
      )
      if (isEmbeded) {
        handleSucAndFailFeedback(false)
      }
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
      style={{ justifyContent: isEmbeded ? 'normal' : 'center' }}
    >
      <div
        className='muiSliderContainer'
        style={{
          height: isEmbeded ? '100%' : '20%',
          marginTop: isEmbeded ? '0px' : '2%',
          pointerEvents:
            explanationClick || completed === 1 || !isActive
              ? 'none'
              : isPractice && followTheFlow && isEmbeded
              ? validateAnswer()
                ? 'none'
                : 'auto'
              : 'auto'
        }}
      >
        <Slider
          style={{ width: '90%' }}
          value={value && value}
          onChange={(event, newValue) => setValue(newValue)}
          aria-labelledby='discrete-slider-small-steps'
          step={1}
          marks={sliderOptions}
          min={1}
          max={slideOptionLength}
          onChangeCommitted={(event, newValue) => {
            handleOptionChange(newValue)
          }}
          disabled={
            explanationClick || completed === 1 || !isActive
              ? true
              : isPractice && followTheFlow && isEmbeded
              ? validateAnswer()
                ? true
                : false
              : false
          }
        />
      </div>
    </div>
  )
}

export default SliderStaticComponent
